<template>
  <div
    class="group border-ontick-steel-300 dark:border-ontick-graphite-500 relative flex transform flex-col overflow-hidden rounded-xl border-2 dark:border-none"
  >
    <div
      class="dark:bg-ontick-graphite-500 relative flex-grow bg-gray-50 px-4 py-3"
    >
      <div class="flex flex-col space-y-2">
        <img
          :src="data.extension_logo"
          :alt="data.extension_name"
          class="bg-ontick-steel-400 h-12 w-12 rounded-lg p-2 dark:bg-transparent dark:p-0"
        />

        <span class="font-bold"> {{ data.extension_name }} </span>
        <p class="text-sm">
          {{ data.extension_plan_desc }}
        </p>
      </div>
      <div class="absolute top-4 right-4">
        <div
          class="text-ontick-steel-500 dark:text-ontick-graphite-200 flex items-center rounded-sm py-0.5 px-1.5 text-xs"
          v-if="data.extension_price"
        >
          <span
            class="text-ontick-carbon-900 text-sm font-bold dark:text-gray-300"
            >{{ data.extension_price | currency }}</span
          ><span>/mês</span>
        </div>
        <ontick-plan-logo-component
          :plan="data.extension_is_free ? 'FREE' : data.required_plan"
          v-else
        />
      </div>
    </div>
    <div
      class="bg-ontick-steel-100 dark:bg-ontick-steel-600 flex items-center justify-end py-3"
    >
      <div class="relative flex w-full items-center">
        <div class="flex flex-1 justify-end">
          <ontick-button
            :disabled="data.active_for_user"
            customClass="text-gray-300 bg-ontick-blue-700 dark:bg-ontick-blue-900 disabled:bg-transparent dark:disabled:bg-transparent disabled:border disabled:border-ontick-green-900 disabled:text-ontick-green-900 dark:disabled:text-ontick-green-600"
            @click.native="
              openDetails({
                extension_id: data.extension_id,
                partner_name: data.extension_owner,
              })
            "
            class="space-x-2 text-sm"
            :class="data.active_for_user ? 'mr-0 cursor-not-allowed' : 'mr-4'"
            size="small"
          >
            <i v-html="$icons.material_check" v-if="data.active_for_user"></i>
            <span v-if="data.active_for_user"> Ativo </span>
            <span v-else> Ver detalhes </span>
          </ontick-button>
        </div>
        <button
          class="text-ontick-graphite-400 hover:text-ontick-carbon-600 relative py-1 px-4 transition dark:hover:text-white"
          @click.stop="toggleDropdown"
          content="Ver detalhes"
          v-tippy="{ arrow: true, theme: 'green' }"
          v-if="data.active_for_user"
        >
          <i v-html="$icons.kebab" class="h-4 w-4"></i>
          <span class="sr-only"> Ver detalhes </span>
        </button>
        <transition
          enter-active-class="transform transition duration-300 ease-custom"
          enter-class="translate-y-1/2 scale-y-0 opacity-0"
          enter-to-class="translate-y-0 scale-y-100 opacity-100"
          leave-active-class="transform transition duration-300 ease-custom"
          leave-class="translate-y-0 scale-y-100 opacity-100"
          leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
        >
          <details-dropdown-component
            v-if="dropdownIsActive"
            @close="deactivateDropdown"
            class="bottom-0 right-0 z-10"
            :detailsId="data.extension_id"
            :owner="data.extension_owner"
            :isActive="data.active_for_user"
            @subscription="$emit('subscription')"
            :price="data.extension_price"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OntickPlanLogoComponent from "../../../../shared/components/basic/ontick-plan-logo.component.vue";
import DetailsDropdownComponent from "./details-dropdown.component.vue";
import PlanBadgeComponent from "./plan-badge.component.vue";
export default {
  components: {
    DetailsDropdownComponent,
    PlanBadgeComponent,
    OntickPlanLogoComponent,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      dropdownIsActive: false,
    };
  },
  methods: {
    ...mapActions({
      setDetailsIsActive: "extensions/setDetailsIsActive",
      setDetailsId: "extensions/setDetailsId",
    }),
    toggleDropdown() {
      this.dropdownIsActive = !this.dropdownIsActive;
    },
    deactivateDropdown() {
      this.dropdownIsActive = false;
    },
    openDetails() {
      this.$router.push({
        name: "Detalhes da extensão",
        params: {
          partner_name: this.data.extension_owner
            .toLowerCase()
            .replaceAll(" ", ""),
          extension_group: this.data.extension_group,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  &-item {
    @apply hover:bg-ontick-steel-400 flex w-full items-center space-x-2 px-3 py-2 text-sm text-gray-300 transition hover:text-white;
  }
  &-icon {
    @apply text-ontick-blue-600 group-hover:text-ontick-blue-400 transition;
  }
}
</style>
